import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import styles from "./CreateCouponForm.module.css";
import axios from "axios";
import toast from "react-hot-toast";
import UploadIcon from "@mui/icons-material/Upload";
import { axiosConfig } from "../../../../axios/axiosConfig";

const CreateCouponForm = ({
  couponDetailsInput,
  setCouponDetailsInput,
  isDeactivate,
  setIsDeactivate,
  handleCouponSubmit,
  handleCouponEditSave,
  isEditMode,
  // activeUserCouponDetails,
}) => {
  const {
    coupon_name,
    coupon_desc,
    coupon_code,
    start_date,
    expiry_date,
    // isActive,
    discount_by, // flat or percentage
    discount_value,
    max_redemption,
    plan_associate_with,
    isHidden,
    banner_image,
    deeplink_url,
    home_screen_visible,
    broker_coupon,
    broker_code,
  } = couponDetailsInput;
  const [planList, setPlanList] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const CREATE_BTN_DISABLED =
    !coupon_name ||
    coupon_name.trim() === "" ||
    !coupon_desc ||
    coupon_desc.trim() === "" ||
    !coupon_code ||
    coupon_code.trim() === "" ||
    !discount_by ||
    discount_by.trim() === "" ||
    !discount_value ||
    discount_value.trim() === "" ||
    !max_redemption ||
    max_redemption.trim() === "" ||
    !start_date ||
    start_date.trim() === "" ||
    !expiry_date ||
    expiry_date.trim() === "";

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axiosConfig({
          method: "get",
          url: "/payment/plans",
        });

        const plans = response?.data;

        if (plans?.status === "success") {
          setPlanList(plans?.response?.data);
        } else {
          toast.error("Failed to fetch plans");
        }
      } catch (error) {
        const errMsg =
          error?.response?.data?.message ||
          error.message ||
          "Error fetching plans";
        toast.error(errMsg);
      }
    };
    fetchPlans();
  }, []);

  // fetch brokers when broker_coupon is toggled to "yes"
  useEffect(() => {
    if (broker_coupon !== "yes") return;
    const fetchBrokers = async () => {
      try {
        const response = await axiosConfig({
          method: "get",
          url: "/referral/broker-list/",
        });
        if (response?.data?.status === "success") {
          setBrokerList(response?.data?.response);
        }
      } catch (error) {
        toast.error("Failed to fetch brokers");
      }
    };
    fetchBrokers();
  }, [broker_coupon]);

  const couponsInputChangeHandler = (event) => {
    // state change for exclusive/hidden toggle only
    if (
      event.target.name === "isHidden" ||
      event.target.name === "home_screen_visible"
    ) {
      setCouponDetailsInput((prevState) => {
        return {
          ...prevState,
          [event.target.name]: event.target.checked,
        };
      });

      return;
    }

    // when broker_coupon switched to "no", clear broker_code
    if (event.target.name === "broker_coupon" && event.target.value === "no") {
      setCouponDetailsInput((prevState) => ({
        ...prevState,
        broker_coupon: "no",
        broker_code: "",
      }));
      return;
    }

    setCouponDetailsInput((prevState) => {
      return {
        ...prevState,
        [event.target.name]: event.target.value,
      };
    });
  };

  // handler for isActive Input
  const isDeactiveOnChange = (event) => {
    // IMPORTANT: IF INPUT IS TRUE/CHECKED, ADMIN WANTS TO DEACTIVATE
    const input = event.target.checked;

    if (input) {
      const prompt = window.confirm("Are you sure you want to deactivate?");

      // if cancelled / false ()
      if (!prompt) return;
    }

    setIsDeactivate(event.target.checked);
  };

  // LABEL STYLING
  const textLabelStyles = {
    textTransform: "uppercase",
    fontWeight: 500,
    letterSpacing: 1,
  };

  return (
    <Box
      sx={{
        maxHeight: "90vh",
        overflowY: "auto",
        overflowX: "hidden",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <Typography
        variant="h5"
        sx={{
          // display: 'inline-block',
          margin: "1rem 0",
          padding: "0.5rem 0",
          textAlign: "center",
          textTransform: "uppercase",
          letterSpacing: 2,
          border: "1px solid #ccc",
          borderRadius: 1,
          // fontWeight: 500,
        }}
      >
        {isEditMode ? "Edit" : "Create"} Coupon
      </Typography>

      {/* EDIT LIMITATIONS MESSAGE */}
      {isEditMode && (
        <div className={styles.editMsgContainer}>
          <p className={styles.editMsg}>Disabled fields are not editable</p>
        </div>
      )}

      {/* form */}
      <Stack spacing={2} sx={{}}>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Coupon Name:{" "}
          </Typography>

          <TextField
            required
            size="small"
            id="coupon_name"
            name="coupon_name"
            label="Coupon Name"
            value={coupon_name}
            onChange={couponsInputChangeHandler}
            // defaultValue="Hello World"
          />
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Description:{" "}
          </Typography>

          <TextField
            required
            size="small"
            id="coupon_desc"
            name="coupon_desc"
            label="Description"
            value={coupon_desc}
            onChange={couponsInputChangeHandler}
            // defaultValue="Hello World"
          />
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            COUPON CODE:{" "}
          </Typography>

          <TextField
            disabled={isEditMode}
            required
            size="small"
            id="coupon_code"
            name="coupon_code"
            label="Coupon Code"
            placeholder="eg. DIWALIOFFER"
            value={coupon_code.toUpperCase()}
            onChange={couponsInputChangeHandler}
            // defaultValue="Hello World"
          />
        </Stack>

        {/* UNABLE TO APPLY FLAT DISCOUNT AS GETTING 'CANT APPLY FLAT DISCOUNT IN INCLUSIVE TAX' ERROR */}
        {/* DISCOUNT TYPE (Flat or Percentage)  */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Discount Type:
          </Typography>

          <select
            disabled={isEditMode}
            required
            name="discount_by"
            id="discount_by"
            value={discount_by}
            onChange={couponsInputChangeHandler}
          >
            {/* <option value="flat">Flat</option> */}
            <option value="percentage">Percentage</option>
            <option value="flat">Amount</option>
          </select>
        </Stack>

        {/* Banner Image */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            Banner Image:
          </Typography>

          <Box
            sx={{
              border: "1px solid #ccc",
              borderRadius: "6px",
              width: "300px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: 1,
            }}
          >
            <input
              type="file"
              accept="image/*"
              id="banner-upload"
              style={{ display: "none" }}
              onChange={(e) =>
                setCouponDetailsInput((prev) => ({
                  ...prev,
                  banner_image: e.target.files[0],
                }))
              }
            />
            <Typography
              sx={{
                fontSize: "0.8rem",
                color: "gray",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flexGrow: 1,
                pr: 1,
              }}
            >
              {banner_image ? banner_image.name : "No file chosen"}
            </Typography>
            <label htmlFor="banner-upload">
              <IconButton
                component="span"
                sx={{ color: "blue", "&:hover": { background: "transparent" } }}
              >
                <UploadIcon />
              </IconButton>
            </label>
          </Box>
        </Stack>

        {/* Deeplink - URL */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Deeplink URL:
          </Typography>

          <TextField
            disabled={isEditMode}
            size="small"
            id="deeplink_url"
            name="deeplink_url"
            label="Deeplink URL"
            placeholder="https://yourapp.page.link/abc"
            value={deeplink_url}
            onChange={couponsInputChangeHandler}
          />
        </Stack>

        {/* DISCOUNT VALUE: Flat discount or Percentage Value in Integer */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Discount Value:{" "}
          </Typography>

          <TextField
            disabled={isEditMode}
            required
            type="number"
            size="small"
            id="discount_value"
            name="discount_value"
            label="Discount Value"
            placeholder="eg. 50"
            value={discount_value}
            onChange={couponsInputChangeHandler}
            // defaultValue="Hello World"
            inputProps={{
              minlength: 0,
              // maxlength: discount_by === 'percentage' ? "100" : null,
              maxLength: 11,
            }}
          />
        </Stack>

        {/* Discount Associated */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Plan Linked:{" "}
          </Typography>
          <select
            name="plan_associate_with"
            id="plan_associate_with"
            value={plan_associate_with}
            onChange={couponsInputChangeHandler}
            style={{
              padding: "0.5rem",
              borderRadius: "4px",
              minWidth: "200px",
            }}
          >
            <option value="">Select a Plan</option>
            {planList &&
              planList.map((plan) => (
                <option key={plan.id} value={plan.id}>
                  {`${plan.name} (${plan.interval} ${plan.interval_unit})`}
                </option>
              ))}
          </select>
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Max Redemptions:
          </Typography>

          <TextField
            // disabled={isEditMode}
            required
            type="number"
            size="small"
            id="max_redemption"
            name="max_redemption"
            label="Max Redemptions"
            placeholder="eg. 100"
            value={max_redemption}
            onChange={couponsInputChangeHandler}
            // defaultValue="Hello World"
            inputProps={{}}
          />
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Start Date:{" "}
          </Typography>

          <input
            disabled={isEditMode}
            required
            type="date"
            min={new Date().toISOString().slice(0, -14)}
            name="start_date"
            id="start_date"
            value={start_date}
            onChange={couponsInputChangeHandler}
          />
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Expiry Date:{" "}
          </Typography>

          <input
            required
            type="date"
            name="expiry_date"
            id="expiry_date"
            value={expiry_date}
            onChange={couponsInputChangeHandler}
          />
        </Stack>

        {/* BROKER COUPON */}
        <Stack
          direction="row"
          spacing={2}
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Broker Coupon:
          </Typography>
          <RadioGroup
            row
            name="broker_coupon"
            value={broker_coupon}
            onChange={couponsInputChangeHandler}
          >
            <FormControlLabel
              value="yes"
              control={<Radio size="small" />}
              label="Yes"
            />
            <FormControlLabel
              value="no"
              control={<Radio size="small" />}
              label="No"
            />
          </RadioGroup>
        </Stack>

        {/* BROKER DROPDOWN — visible only when broker_coupon is "yes" */}
        {broker_coupon === "yes" && (
          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography variant="subtitle1" sx={textLabelStyles}>
              Broker:
            </Typography>
            <select
              name="broker_code"
              value={broker_code}
              onChange={couponsInputChangeHandler}
              style={{
                padding: "0.5rem",
                borderRadius: "4px",
                minWidth: "200px",
              }}
            >
              <option value="">Select Broker</option>
              {brokerList.map((broker) => (
                <option key={broker.id} value={broker.referral_code}>
                  {broker.broker_name}
                </option>
              ))}
            </select>
          </Stack>
        )}

        {/* HIDDEN / EXLUSIVE OFFER TOGGLE */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Exclusive for Specific Users?
          </Typography>

          <input
            required
            type="checkbox"
            name="isHidden"
            id="isHidden"
            value={isHidden}
            onChange={couponsInputChangeHandler}
          />
        </Stack>

        {/* Home screen visible */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="subtitle1" sx={textLabelStyles}>
            Show on Home Screen?
          </Typography>

          <input
            required
            type="checkbox"
            name="home_screen_visible"
            checked={home_screen_visible}
            id="home_screen_visible"
            onChange={couponsInputChangeHandler}
          />
        </Stack>

        {/* ONLY SHOW CHECK BOX IF EDIT MODE IS ON */}
        {isEditMode ? (
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1">
              Deactivate? (Active if unchecked):
            </Typography>

            <Checkbox
              // checked={isActiveInput}
              checked={isDeactivate}
              // onChange={handleChange}
              onChange={isDeactiveOnChange}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Stack>
        ) : null}

        {/* BUTTONS */}
        <div
          style={{
            margin: "2rem",
          }}
        >
          {isEditMode ? (
            <Stack>
              <Button variant="contained" onClick={handleCouponEditSave}>
                save
              </Button>
            </Stack>
          ) : (
            <Stack>
              <Button
                disabled={CREATE_BTN_DISABLED}
                variant="contained"
                onClick={handleCouponSubmit}
              >
                create
              </Button>
            </Stack>
          )}
        </div>
      </Stack>
    </Box>
  );
};

export default CreateCouponForm;
